const buttonTypes = {
  All: 'all',
  Active: 'active',
  Approved: 'approved',
  NotApproved: 'not_approved',
  Archived: 'archived',
  Compliant: 'compliant',
  NonCompliant: 'non_compliant',
  Deleted: 'deleted'
};

export const ButtonColorSchemes = {
  [buttonTypes.All]: {
    backgroundColor: 'primaryScale.50',
    color: 'primaryScale.600'
  },
  [buttonTypes.Active]: {
    backgroundColor: 'rgba(63, 140, 255, 0.12)',
    color: 'primaryScale.400'
  },
  [buttonTypes.Approved]: {
    backgroundColor: 'success.primary.600',
    color: 'white'
  },
  [buttonTypes.NotApproved]: {
    backgroundColor: 'rgba(247, 104, 91, 0.12)',
    color: 'error.primary.600'
  },
  [buttonTypes.Archived]: {
    backgroundColor: 'rgba(125, 133, 146, 0.14)',
    color: 'greyScale.800'
  },
  [buttonTypes.Deleted]: {
    backgroundColor: 'rgba(125, 133, 146, 0.14)',
    color: 'greyScale.800'
  },
  [buttonTypes.Compliant]: {
    backgroundColor: 'primaryScale.50',
    color: 'primaryScale.600'
  },
  [buttonTypes.NonCompliant]: {
    backgroundColor: 'rgba(247, 104, 91, 0.12)',
    color: 'error.primary.600'
  }
};

export const getButtonColors = type => {
  if (!ButtonColorSchemes[type]) {
    throw new Error(`button type of ${type} does not exist`);
  }

  return ButtonColorSchemes[type];
};

export const statusOptions = {
  active: {
    id: 'active',
    displayName: 'Active Records'
  },
  all: {
    id: 'all',
    displayName: 'All Records',
    search: { text: 'All', value: 'all' }
  },
  approved: {
    id: 'approved',
    displayName: 'Approved Records',
    search: { text: 'Approved', value: 'approved' }
  },
  not_approved: {
    id: 'not_approved',
    displayName: 'Not Approved Records',
    search: { text: 'Not Approved', value: 'not_approved' }
  },
  archived: {
    id: 'archived',
    displayName: 'Archived Records',
    search: { text: 'Archived', value: 'archived' }
  }
};
